import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { UdtPlotComponent } from '../wellbore-inputs/components/udt-plot/udt-plot.component';
import { UndisturbedTemperatureV2Component } from '../wellbore-inputs/components/undisturbed-temperature-v2/undisturbed-temperature-v2.component';
import { UdtTemperatureInterpolatorComponent } from '../wellbore-inputs/components/undisturbed-temperature/udt-temperature-interpolator/udt-temperature-interpolator.component';
import { UdtConstantGradientV2Component } from '../wellbore-inputs/components/undisturbed-temperature/udt-constant-gradient-v2/udt-constant-gradient-v2.component';
import { UdtCustomPointsV2Component } from '../wellbore-inputs/components/undisturbed-temperature/udt-custom-points-v2/udt-custom-points-v2.component';
import { TrajectoryGridComponent } from '../wellbore-inputs/components/trajectory-grid/trajectory-grid.component';
import { InterpolationToolComponent } from '../wellbore-inputs/components/interpolation-tool/interpolation-tool.component';
import { CementingLandingComponent } from '../wellbore-inputs/components/cementing-landing/cementing-landing.component';
import { WellTypeDatumsComponent } from '../wellbore-inputs/components/well-type-datums/well-type-datums.component';
import { WellConfigurationComponent } from '../wellbore-inputs/components/well-configuration/well-configuration.component';
import { PackersComponent } from '../wellbore-inputs/components/packers/packers.component';

import { SharedModule } from './shared.module';
import { PerforationsComponent } from '../wellbore-inputs/components/perforations/perforations.component';
import { FormationTopsComponent } from '../wellbore-inputs/components/formation-tops/formation-tops.component';
import { TrajectoryPlotContainerComponent } from '../wellbore-inputs/components/trajectory-plot/trajectory-plot-container.component';
import { ThreeDeePlotComponent } from '../wellbore-inputs/components/trajectory-plot/3dPlot/3Dplot.component';
import { TwoDeePlotComponent } from '../wellbore-inputs/components/trajectory-plot/2dPlot/2Dplot.component';
import { SchematicInfoComponent } from '../wellbore-inputs/components/well-schematic/schematic-info.component';
import { WellSchematicComponent } from '../wellbore-inputs/components/well-schematic/well-schematic.component';
import { DrillstringComponent } from '../wellbore-inputs/components/drillstring/drillstring.component';
import { Drillstring2Component } from '../wellbore-inputs/components/drillstring2/drillstring2.component';
import { WellheadComponent } from '../wellbore-inputs/components/wellhead/wellhead.component';
import { ExpansionJointComponent } from '../wellbore-inputs/components/packers/expansion-joint/expansion-joint.component';
import { PackerDataComponent } from '../wellbore-inputs/components/packers/packer-data/packer-data.component';
import { PackerSchematicComponent } from '../wellbore-inputs/components/packers/packer-schematic/packer-schematic.component';
import { ChokesComponent } from '../perical/components/chokes/chokes.component';
import { ChokeDataComponent } from '../perical/components/chokes/choke-data/choke-data.component';
import { AnnulusContentsComponent } from '../wellbore-inputs/components/annulus-contents/annulus-contents.component';
import { RiserComponentComponent } from '../wellbore-inputs/components/riser-component/riser-component.component';
import { EspComponent } from '../wellbore-inputs/components/esp/esp.component';
import { EspDataComponent } from '../wellbore-inputs/components/esp/esp-data/esp-data.component';
import { DrillPlanImportComponent } from '../wellbore-inputs/components/drill-plan-import/drill-plan-import.component';
import { WellCatImportComponent } from '../wellbore-inputs/components/well-cat-import/well-cat-import.component';

const components = [
  PackersComponent,
  TrajectoryGridComponent,
  TrajectoryPlotContainerComponent,
  ThreeDeePlotComponent,
  TwoDeePlotComponent,
  InterpolationToolComponent,
  UdtPlotComponent,
  CementingLandingComponent,
  UndisturbedTemperatureV2Component,
  UdtTemperatureInterpolatorComponent,
  UdtConstantGradientV2Component,
  UdtCustomPointsV2Component,
  WellConfigurationComponent,
  WellSchematicComponent,
  SchematicInfoComponent,
  WellTypeDatumsComponent,
  PerforationsComponent,
  FormationTopsComponent,
  DrillstringComponent,
  Drillstring2Component,
  WellheadComponent,
  ExpansionJointComponent,
  PackerDataComponent,
  PackerSchematicComponent,
  ChokesComponent,
  ChokeDataComponent,
  AnnulusContentsComponent,
  RiserComponentComponent,
  EspComponent,
  EspDataComponent,
  DrillPlanImportComponent,
  WellCatImportComponent
];

@NgModule({
  declarations: [
    ...components
  ],
  imports: [
    CommonModule,
    SharedModule
  ],
  exports: [
    ...components
  ]
})
export class WellboreInputsModule { }
